<div class="main-content" [style.background-color]="viewModel.cardColor$ | async"></div>
